<template src="./Index.html">
</template>


<script>
import AddView from './actions/Add.vue';
import EditView from "./actions/Edit.vue";
import DetailsView from "./actions/Details.vue";

export default {
  components: {
    AddView,
    EditView,
    DetailsView,
  },
  created() {
    this.getAll();
  },
  computed: {
    pageCount() {
      return Math.ceil(
        this.$store.state.employees.totalItems / this.filters.pageSize
      );
    },
    employees() {

      return this.$store.state.employees.employees;
    },

  },

  data() {
    return {
      permissions: this.$settingPermissions.EmployeesPermissions,

      view: 0,
      filters: {
        page: 1,
        pageSize: 10,

        name: null,
        departmentId: null,
      },
      headers: [
        { text: 'الاسم', value: 'fullName' },
        { text: 'القسم', value: 'departmentName' },
        { text: 'الوصف الوظيفي', value: 'jobDescription' },
        // { text: 'رقم الهاتف', value: 'phone' },
        { text: "مسجل بواسطة", value: "createdBy", sortable: false },
        { text: "تاريخ التسجيل", value: "createdOn", sortable: false },

        { text: 'الاجراءات', value: 'actions', sortable: false },
      ],
      dialog: false,
      dialogType: null,
      dialogMessage: "",

      itemId: 0,
    };
  },
  methods: {
    getAll(page) {
      this.filters.page = page || 1;
      this.$store.dispatch("employees/getAll", this.filters);

    },

    addItem() {
      this.view = 1;
    },
    viewItem(item) {
      this.itemId = item.id;
      this.view = 3;
      // Implement view logic
    },
    editItem(item) {
      this.itemId = item.id;
      this.view = 2;
      // Implement edit logic
    },
    back() {
      this.view = 0;
    },
    // // -------------- end empDialog  -----
    showDialog(item, type) {
      switch (type) {
        case "delete":
          this.dialogMessage = "هل انت متأكد من رغبتك حذف البيانات";
          break;
        // case "lock":
        //     this.dialogMessage = "هل انت متأكد من رغبتك تجميد البيانات";
        //     break;
        // case "unlock":
        //     this.dialogMessage = "هل انت متأكد من رغبتك تفعيل البيانات";
        //     break;
      }
      this.dialogType = type;
      this.itemId = item.id;
      this.dialog = true;
    },

    confirmDialog() {
      this.$store.dispatch(`employees/${this.dialogType}`, this.itemId);
      this.cancelDialog();
    },

    cancelDialog() {
      this.dialog = false;
      this.itemId = 0;
      this.dialogMessage = "";
      this.dialogType = null;
    },
  },
};
</script>

<style scoped></style>